export default __webpack_public_path__ + "static/media/faqIcon.c4d47c08.svg";